export const text = {
  Box: "Box",
  AddAssetCategory: "Add Asset Category",
  AddAsset: "Add Asset",
  AddBookAsset: "Add Book Asset",
  AssetCategory: "Asset Category",
  AssetList: "Asset List",
  BookAsset: "Book Asset",
  SelectAssetType: "Select Asset Type",
  Asset: "Asset",
  Category: "Category",
  Pending: "Pending",
  Approved: "Approved",
  Rejected: "Rejected",
  Cancelled: "Cancelled",
  Assetaddedsuccessfully: "Asset added successfully!",
  AnAssetImageisrequired: "An Asset Image is required.",
  Assetupdatedsuccessfully: "Asset updated successfully!",
  AnAssetImageisrequired: "An Asset Image is required.",
  AssetDeletedsuccessfully: "Asset Deleted successfully!",
  Assetcategoryaddedsuccessfully: "Asset category added successfully!",
  AnCategoryImageisrequired: "An Category Image is required.",
  Assetcategoryupdatedsuccessfully: "Asset category updated successfully!",
  AnCategoryImageisrequired: "An Category Image is required.",
  AnCategoryTitleisrequired: "An Category Title is required.",
  AssetcategoryDeletedsuccessfully: "Asset category Deleted successfully!",
  BookAssetaddedsuccessfully: "Book Asset added successfully!",
  BookAssetupdatedsuccessfully: "Book Asset updated successfully!",
  BookAssetDeletedsuccessfully: "Book Asset Deleted successfully!",
};
